import { Prisma } from "@tfg/db"
import z from "zod"

import { kebabCaseSchema } from "@tfg/types/schemas/utils"

export const createDisplaySettingSchema = z.object({
  id: z.string().uuid(),
  organizationSettingsId: z.number(),
  searchEngine: z.boolean(),
  agecProductPage: z.boolean(),
  slug: kebabCaseSchema,
  filters: z.custom<Prisma.JsonObject>(),
  outputBackgroundColor: z.string().optional(),
  outputHeaderBackgroundColor: z.string().optional(),
  outputTextBodyColor: z.string().optional(),
  outputTitlesColor: z.string().optional(),
  customPage: z.string().optional(),
  outputLogoUrl: z.string().optional(),
})

export type createDisplaySettingValidationType = z.infer<
  typeof createDisplaySettingSchema
>

export type updateDisplaySettingValidationType =
  createDisplaySettingValidationType
